const usePupilData = () => {
  return JSON.parse(localStorage.getItem('pupil'))
}

export default usePupilData
